import { ReactNode } from "react";
import { UseFormRegister } from "react-hook-form";

interface Props {
  register: UseFormRegister<any>;
  required?: boolean;
  name: string;
  value: string | number | undefined;
  label: string | ReactNode;
}

const Radio: React.FC<Props> = ({ label, value, name, register, required }) => (
  <label className="flex justify-between p-2">
    {label}
    <input
      value={value}
      type="radio"
      className="rounded-full checkbox checkbox-primary border-pkc-secondary"
      {...register(name, { required })}
    />
  </label>
);

export default Radio;
